import img from "./Images";

const testimonial = [
  {
    name: "kirthikiran",
    feedback:
      "very responsive and did the job efficiently as instructed. Recommended 100% 👍🏻",
    company: "India",
    imgUrl: img.fiver,
  },
  {
    name: "rameezamemon",
    feedback:
      "Nazmuln has done an amazing work in understanding the task and getting it done in a matter of hours, edits included. Will definitely work together again.",
    company: "Pakistan",
    imgUrl: img.fiver,
  },
];
export default testimonial;
